import { FILTER_DATE_TO } from './constants'

export const filterDateTo = (date = '', event = null) => ({
  type: FILTER_DATE_TO,
  date,
  event,
})
